<template>
  <div
    class="tw-fixed tw-left-0 tw-right-0 tw-z-[100]"
    :class="isSelectionMode
      ? 'tw-bottom-0 tw-h-[141px] xs2:tw-h-[80px] tw-bg-white tw-shadow-[0_-4px_4px_0_rgba(0,0,0,0.1)]'
      : 'tw-bottom-[16px] tw-h-[80px] tw-bg-transparent tw-shadow-none xs2:tw-bottom-0 xs2:tw-bg-white xs2:tw-shadow-[0_-4px_4px_0_rgba(0,0,0,0.1)]'"
    data-shortlist-enquiry-footer
    :data-enquiry-selection-mode="isSelectionMode ? 'true' : null"
    :data-testid="isSelectionMode ? 'shortlist-enquiry-selection-footer' : null"
  >
    <div
      class="tw-mx-auto tw-flex tw-h-full tw-w-full tw-max-w-screen-xl tw-px-[16px] mdm:tw-w-[calc(100%_-_48px)] mdm:tw-px-0"
      :class="[
        isSelectionMode
          ? 'tw-flex-col tw-items-stretch tw-justify-center tw-gap-2 tw-py-[16px] xs2:tw-py-0 xs:tw-flex-row xs:tw-items-center xs:tw-justify-between xs:tw-gap-0'
          : 'tw-items-end tw-justify-center xs2:tw-items-center xs2:tw-justify-end sm:tw-justify-between',
      ]"
    >
      <template v-if="isSelectionMode">
        <span
          class="tw-hidden tw-whitespace-nowrap tw-text-left tw-text-[16px] tw-font-semibold tw-text-[#3B4143] xs2:tw-block mdm:tw-text-[18px]"
        >
          {{ selectedCount }}
          {{ selectedCount === 1 ? 'Property' : 'Properties' }} selected
        </span>
        <div
          class="tw-mx-auto tw-flex tw-w-full tw-flex-col tw-items-stretch tw-gap-2 xs2:tw-mx-0 xs2:tw-w-auto xs2:tw-flex-row xs2:tw-items-center xs2:tw-gap-3"
        >
          <button
            type="button"
            :class="[
              buttonBaseClasses,
              'tw-order-2 tw-h-[36px] tw-rounded-full tw-border-0 tw-bg-transparent tw-px-0 tw-text-[16px] tw-text-[#00628F] hover:tw-bg-transparent xs2:tw-order-none xs2:tw-h-[50px] xs2:tw-border xs2:tw-border-[#F48831] xs2:tw-bg-white xs2:tw-px-[16px] xs2:tw-text-[#F48831] xs2:hover:tw-bg-orange-50',
            ]"
            data-testid="shortlist-cancel-selection"
            @click="$emit('cancel')"
          >
            Cancel selection
          </button>
          <button
            type="button"
            :class="[
              buttonBaseClasses,
              'tw-order-1 tw-w-full tw-rounded-full tw-bg-[#F48831] tw-text-[16px] tw-text-white hover:tw-bg-[#E16B0C] disabled:tw-cursor-not-allowed disabled:tw-bg-[#9CA3AF] xs2:tw-order-none xs2:tw-w-auto xs2:tw-px-[16px]',
            ]"
            :disabled="selectedCount === 0"
            data-testid="shortlist-enquiry-continue"
            @click="$emit('continue')"
          >
            Continue
          </button>
        </div>
      </template>
      <template v-else>
        <div class="tw-hidden tw-flex-col tw-text-left sm:tw-flex">
          <span
            class="tw-text-[18px] tw-font-semibold tw-leading-[27px] tw-text-[#3B4143]"
          >
            Ready to enquire?
          </span>
          <span class="tw-text-[14px] tw-leading-[21px] tw-text-[#6B7280]">
            Choose properties from this list
          </span>
        </div>
        <button
          type="button"
          :class="[
            buttonBaseClasses,
            'tw-h-[46px] tw-w-[180px] tw-shrink-0 tw-rounded-full tw-border-0 tw-bg-[#00628F] tw-text-[16px] tw-text-white hover:tw-bg-[#005479] xs2:tw-h-[50px] xs2:tw-w-[162px] xs2:tw-rounded-[30px] xs2:tw-border xs2:tw-border-white xs2:tw-bg-[#F48831] xs2:hover:tw-bg-[#E16B0C]',
          ]"
          data-testid="shortlist-enquire-now"
          @click="$emit('start')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="15"
            viewBox="0 0 20 15"
            fill="none"
          >
            <path
              d="M18.75 0H0.75C0.551088 0 0.360322 0.0790178 0.21967 0.21967C0.0790176 0.360322 0 0.551088 0 0.75V13.5C0 13.8978 0.158035 14.2794 0.43934 14.5607C0.720644 14.842 1.10218 15 1.5 15H18C18.3978 15 18.7794 14.842 19.0607 14.5607C19.342 14.2794 19.5 13.8978 19.5 13.5V0.75C19.5 0.551088 19.421 0.360322 19.2803 0.21967C19.1397 0.0790178 18.9489 0 18.75 0ZM9.75 7.98281L2.67844 1.5H16.8216L9.75 7.98281ZM7.00406 7.5L1.5 12.5447V2.45531L7.00406 7.5ZM8.11406 8.51719L9.23906 9.55312C9.37743 9.68014 9.55842 9.75062 9.74625 9.75062C9.93408 9.75062 10.1151 9.68014 10.2534 9.55312L11.3784 8.51719L16.8159 13.5H2.67844L8.11406 8.51719ZM12.4959 7.5L18 2.45438V12.5456L12.4959 7.5Z"
              fill="white"
            />
          </svg>
          Enquire now
        </button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['start', 'cancel', 'continue'],

  computed: {
    buttonBaseClasses() {
      return 'tw-inline-flex tw-h-[50px] tw-px-[16px] tw-py-[4px] tw-items-center tw-justify-center tw-gap-2  tw-font-semibold focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2';
    },
  },

  props: {
    isSelectionMode: {
      default: false,
      type: Boolean,
    },
    selectedCount: {
      default: 0,
      type: Number,
    },
  },
};
</script>
